<template>
  <div>
    <div v-if="!isLoading">
      <b-row class="steps-tunnel w-75 mt-3 mb-5">
        <!-- step1 btn -->
        <b-col cols="auto step-btn-block">
          <b-button
            class="button btn-step"
            :class="{ 'btn-step-active': currentStep == 1 }"
            @click="changeStep(1)"
          >
            1
          </b-button>
        </b-col>
        <b-col class="step-line"></b-col>
        <!-- step2 btn -->
        <b-col cols="auto step-btn-block">
          <b-button
            class="button btn-step"
            :class="{ 'btn-step-active': currentStep == 2 }"
            :disabled="!step1ok || noBuildingLotsSelected"
            @click="changeStep(2)"
          >
            2
          </b-button>
        </b-col>
      </b-row>
      <div class="contact-block">
        <appStep1
          v-if="currentStep == 1"
          ref="step-1"
          :building-lots-to-sale="buildingLotsToSale"
          :building-owner-lots-data="buildingOwnerLotsData"
          @updateBuildingLotsToSale="updateBuildingLotsToSale"
        />
        <appStep2
          v-if="currentStep == 2"
          ref="step-2"
          :new-owner-type="newOwnerType"
          :existing-building-owner-id="existingBuildingOwnerId"
          :new-building-owner="newBuildingOwner"
          :building-owner-id="buildingOwnerId"
          :building-id="buildingId"
          @updateNewOwnerType="updateNewOwnerType"
          @updateExistingBuildingOwnerId="updateExistingBuildingOwnerId"
          @updateNewBuildingOwner="updateNewBuildingOwner"
        />

        <!-- cancel, create, update -->
        <b-row class="mt-5 mb-2 justify-content-end">
          <b-col v-if="currentStep === 1" cols="auto">
            <b-button
              :disabled="noBuildingLotsSelected"
              class="button btn-blue"
              @click="goToNextStep"
            >
              <font-awesome-icon icon="arrow-right" />
              <span class="ml-2">{{ $t("general.continue") }}</span>
            </b-button>
          </b-col>
          <b-col v-if="currentStep === 2" cols="auto">
            <b-button class="button btn-blue" @click="departBuildingLots">
              <font-awesome-icon icon="save" />
              <span class="ml-2">{{ $t("general.enregistrer") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <appLoader v-else />
  </div>
</template>
<script>
import { validate } from "vee-validate";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import BuildingOwnerMW from "@/middlewares/BuildingOwner";

import { departBuildingLotNewOwnerTypes } from "@/constants/building.js";

export default {
  components: {
    appStep1,
    appStep2,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    buildingOwnerId: {
      type: String,
      required: true,
    },
    buildingId: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      departBuildingLotNewOwnerTypes,
      isLoading: false,
      currentStep: 1,
      step1ok: false,
      buildingOwnerLotsData: {},

      buildingLotsToSale: [],
      newOwnerType: departBuildingLotNewOwnerTypes.existing,
      existingBuildingOwnerId: null,
      newBuildingOwner: {
        agency_id: Number(localStorage.getItem("agencyId")),
        building_id: this.buildingId,
        number: "",
        address: "",
        complement: "",
        complement2: "",
        zipcode: "",
        city: "",
        country: "",
        contact_type: 1,
        entity_type: 1,
        can_vote: 0,
        gender: 1,
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        user_id: "",
        username: "",
        password: "",
        owner_left: 0,
      },
    };
  },
  computed: {
    noBuildingLotsSelected() {
      return this.buildingLotsToSale.length == 0;
    },
  },
  created() {
    this.buildingOwnerLotsData = this.$_.find(this.items, item => {
      return item.id == this.buildingOwnerId;
    });
  },
  methods: {
    updateBuildingLotsToSale(checked, id) {
      if (checked) {
        this.buildingLotsToSale.push(id);
      } else {
        let index = this.buildingLotsToSale.findIndex(element => {
          return element == id;
        });
        this.buildingLotsToSale.splice(index, 1);
      }
    },
    updateNewOwnerType(value) {
      this.newOwnerType = value;
    },
    updateExistingBuildingOwnerId(value) {
      this.existingBuildingOwnerId = value;
    },
    updateNewBuildingOwner(key, value) {
      this.newBuildingOwner[key] = value;
    },
    async departBuildingLots() {
      if (!(await this.validateStep())) {
        return;
      }

      try {
        this.isLoading = true;

        var res = await BuildingOwnerMW.CHECK_IF_DEPART_BUILDING_LOT_CAN_BE_EXECUTED({
          oldOwnerId: this.buildingOwnerId,
          newOwnerId:
            this.newOwnerType == this.departBuildingLotNewOwnerTypes.existing
              ? this.existingBuildingOwnerId
              : "",
        });

        if (res.response) {
          if (this.newOwnerType == this.departBuildingLotNewOwnerTypes.existing) {
            await this.executeDepartBuildingLot(this.existingBuildingOwnerId);
          } else if (this.newOwnerType == this.departBuildingLotNewOwnerTypes.new) {
            await this.registerBuildingOwner();
            await this.createBuildingOwner();
            await this.executeDepartBuildingLot(this.newBuildingOwner.id);
          }

          this.refetchTableData();
        } else {
          this.$swal({
            icon: "warning",
            title:
              "Impossible de quitter le lot car l'un des propriétaires a une réunion en cours !",
            text: "Réinitialiser la réunion avant de faire l'opération",
            showConfirmButton: true,
            timer: 7000,
          });
        }

        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;

        console.error(err);
        this.$swal(this.alertError());
      }
    },
    async registerBuildingOwner() {
      await BuildingOwnerMW.REGISTER(this.newBuildingOwner).then(res => {
        this.newBuildingOwner.user_id = res.userId;
        this.newBuildingOwner.username = res.username;
        this.newBuildingOwner.password = res.password;
      });
    },
    async createBuildingOwner() {
      await BuildingOwnerMW.POST(this.newBuildingOwner).then(res => {
        this.newBuildingOwner.id = res.id;
      });
    },
    async executeDepartBuildingLot(newOwnerId) {
      await BuildingOwnerMW.EXECUTE_DEPART_BUILDING_LOT({
        oldOwnerId: this.buildingOwnerId,
        newOwnerId,
        buildingLotsToSale: this.buildingLotsToSale,
      });
    },

    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }

      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }
      if (this.currentStep == 1) this.step1ok = true;
      this.currentStep++;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        if (this.noBuildingLotsSelected) {
          valid = false;
        }
      } else if (this.currentStep == 2) {
        if (this.newOwnerType == this.departBuildingLotNewOwnerTypes.new) {
          let values = [
            {
              key: "lastname",
              rules: "required",
            },
            {
              key: "address",
              rules: "required",
            },
            {
              key: "zipcode",
              rules: "required",
            },
            {
              key: "city",
              rules: "required",
            },
            {
              key: "country",
              rules: "required",
            },
            {
              key: "contact_type",
              rules: "required",
            },
            {
              key: "email",
              rules:
                this.newBuildingOwner.contact_type == this.contactTypes.email ? "required" : "",
            },
          ];
          for (const value of values) {
            await validate(this.newBuildingOwner[value.key], value.rules, {}).then(res => {
              if (!res.valid) {
                valid = false;
                this.$refs["step-2"].$refs["vee-b-owner-" + value.key].validate();
              }
            });
          }
        } else if (this.newOwnerType == this.departBuildingLotNewOwnerTypes.existing) {
          await validate(this.existingBuildingOwnerId, "required", {}).then(res => {
            if (!res.valid) {
              valid = false;
              this.$refs["step-2"].$refs["vee-existing-b-owner"].validate();
            }
          });
        }
      }
      return valid;
    },
    refetchTableData() {
      this.$emit("refetchTableData");
    },
  },
};
</script>
